/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["color-controls-drawer{display:block}color-controls-drawer color-widget{margin:0 auto}"];
export { styles as styles };
